export const API_DATA_URL = '/api/v1/data'
export const API_SERVICE_URL = '/api/v1/service'
export const API_LOG_URL = '/api/v1/log'
export const API_LOG_ERROR_URL = '/api/v1/log/error'
export const API_SPEECH_URL = '/api/v1/speech'
export const API_SETTINGS_URL = '/api/v1/settings'
export const API_AUTH_BASE_URL = '/api/auth'
export const API_ADMIN_BASE_URL = '/api/v1/admin'
export const API_AUTH_VERIFY_URL = '/auth/verify'
export const API_AUTH_ACTIVATE_PARENT_URL = '/api/auth/activate-parent'
export const API_AUTH_REGISTER_EVENT_INSTANT_URL = '/api/auth/register/event-instant'
export const API_ONBOARDING_WELCOME_ACCEPTED_URL = '/api/v1/service/onboarding/welcome-accepted'
